import { useContext, useEffect, useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { LocalizationContext } from 'localization';

export const DEMO_ROOT_TITLE =
  'Демо SmartShell — программа для компьютерного клуба';

export const getDocumentTitle = (
  pathname: string,
  title: string | null
): string | null => {
  if (!title) {
    return null;
  }

  return pathname === '/' ? DEMO_ROOT_TITLE : `${title}: SmartShell`;
};

const getTitle = (
  pathname: string,
  titlesMap: Record<string, string>
): string | null => {
  const splitPath = pathname
    .split('/')
    .filter((part) => part)
    .map((part) => '/' + part);

  if (!splitPath.length) {
    return titlesMap['/'];
  }

  for (let i = splitPath.length - 1; i >= 0; i--) {
    const title = titlesMap[splitPath.join('')];

    if (title) {
      return title;
    }

    splitPath.pop();
  }

  return null;
};

export const usePageTitles = (): string | null => {
  const { t } = useContext(LocalizationContext);
  const { pathname } = useLocation();

  const PAGE_TITLES_MAP: Record<string, string> = useMemo(
    () => ({
      '/': t('nav.dashboard'),
      '/computers': t('nav.hosts'),
      '/map': t('nav.map'),
      '/bookings': t('nav.booking'),
      '/clients': t('nav.clients'),
      '/login': t('nav.auth'),
      '/logs': t('nav.logs'),
      '/payments': t('nav.payments'),
      '/shop': t('nav.shop'),
      '/tariffs': t('nav.tariffs'),
      '/tariff': t('nav.tariffs'),
      '/goods': t('nav.goods'),
      '/services': t('nav.services'),
      '/combos': t('nav.combos'),
      '/promo-codes': t('nav.promo'),
      '/promo-code': t('nav.promo'),
      '/promo-campaign': t('nav.promo'),
      '/discounts': t('nav.discounts'),
      '/cashback': t('nav.cashback'),
      '/workers': t('nav.workers'),
      '/game-accounts': t('nav.gameAccounts'),
      '/applications': t('nav.applications'),
      '/applications/manage': t('nav.applications'),
      '/reviews': t('nav.reviews'),
      '/settings': t('nav.settings'),
      '/reports': t('nav.analytics'),
      '/achievements': t('nav.achievements'),
      '/news': t('nav.news'),
      '/advertisement': t('nav.advertisement'),
    }),
    [t]
  );

  const title = getTitle(pathname, PAGE_TITLES_MAP);

  useEffect(() => {
    const documentTitle = getDocumentTitle(pathname, title);

    if (documentTitle) {
      document.title = documentTitle;
    }
  }, [pathname, title]);

  return title;
};
